import "./ToursExcursions.module.css";
import Header from "@/reusable_sections/Header";
import ToursIntro from "./sections/ToursIntro";
import Excursions from "./sections/Excursions";
import WhyBookWithUs from "./sections/WhyBookWithUs";
import Footer from "@/reusable_sections/Footer";
export default function ToursExcursionsPage() {
  return <div>
      <Header />
      <ToursIntro />
      <WhyBookWithUs />
      <Excursions />
      <Footer />
    </div>;
}